<app-page headline="Product Catalog">
  <div grid-layout gap="md" templateColumns="1fr 1fr">
    <div
      stack-layout
      borderRadius="xs"
      border="light"
      padding="lg"
      gap="lg"
      alignItems="center"
      [minWidth]="460"
      elevation="raised"
    >
      <Text role="headline-small"> Product Catalog Data </Text>

      <app-download-button
        mode="text"
        [blobObservable]="productService.downloadProducts()"
        [downloadFileName]="getProductCatalogFileName()"
        noContentMessage="No product catalog data found."
      />
    </div>

    @if (permissionToSync()) {
      <div
        stack-layout
        borderRadius="xs"
        border="light"
        padding="lg"
        gap="lg"
        alignItems="center"
        [minWidth]="460"
        elevation="raised"
      >
        <Text role="headline-small"> Synchronize Product Data </Text>

        <button text-button size="md" (click)="synchronizeProductData()">
          Sync
        </button>
      </div>
    }
  </div>

  <div box-layout paddingVertical="md" [grow]="1">
    @if (productService.noDataSyncHistory()) {
      <div center-layout [grow]="1" [fullWidth]="true">
        <Text role="title-large">No product sync history.</Text>
      </div>
    }

    <app-log-table
      [datasource]="dataSyncHistoryDatasource"
      label="Sync Data History"
      [loading]="productService.dataSyncHistory.isLoading()"
      (reload)="productService.dataSyncHistory.reload()"
    />
  </div>
</app-page>
